// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-health-health-tsx": () => import("./../../../src/templates/health/health.tsx" /* webpackChunkName: "component---src-templates-health-health-tsx" */),
  "component---src-templates-index-unscr-2286-index-unscr-2286-tsx": () => import("./../../../src/templates/index-unscr2286/index-unscr2286.tsx" /* webpackChunkName: "component---src-templates-index-unscr-2286-index-unscr-2286-tsx" */)
}

